module.exports = __webpack_public_path__ + "static/media/about-us.13f98d8e.svg";